export default __webpack_public_path__ + "static/media/Img0024.c6ff453d.png";